import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import cookie from 'js-cookie';
import withProps from 'recompose/withProps';
import { withState, lifecycle } from 'recompose';
import withHandlers from 'recompose/withHandlers';
import formatPrismicData from '../../hocs/formatPrismicData';
import SignInPartial from './SignInPartial';
import withCountry from '../../hocs/withCountry';
import withMediaQueries from '../../hocs/withMediaQueries';
import { trackGeneralClick } from '../../../analytics/category/checkout';


const enhance = compose(
  formatPrismicData,
  withCountry,
  withRouter,
  withMediaQueries,
  withState('isUserLoggedIn', 'setIsUserLoggedIn', false),
  withProps(props => ({
    returnToUrl: props.match.url,
  })),
  lifecycle({
    componentDidMount() {
      if (!!cookie.get('restricted_user_id') && !!cookie.get('isAuthenticated')) {
        this.props.setIsUserLoggedIn(true);
      }
    }
  }),
  withHandlers({
    handleClick: props => event => {
      trackGeneralClick('Sign In Partial');
    },
  })
);

export default enhance(SignInPartial);



// WEBPACK FOOTER //
// ./src/client/js/view/components/SignInPartial/index.js